import { Typography } from '@mui/material';
import {
  AutocompleteInput,
  BooleanInput,
  DateTimeInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import { useWatch } from 'react-hook-form';

import { UpdateChannel } from 'types/UpdateChannel';

interface AddSoftwareReleaseFormProps {
  record?: UpdateChannel;
  resource?: string;
}

const ReleaseInputs = () => {
  const releaseSelected = useWatch({ name: 'software_release_id' });
  const releaseNow = useWatch({ name: 'release_now' });

  return (
    releaseSelected && (
      <>
        <DateTimeInput source="released_at" fullWidth disabled={releaseNow} />
        <BooleanInput source="release_now" />
      </>
    )
  );
};

export const AddSoftwareReleaseForm = (props: AddSoftwareReleaseFormProps) => {
  const record = useRecordContext<UpdateChannel>(props);
  const translate = useTranslate();

  const selectedHardwareId = useWatch({ name: 'hardware_id' });
  const selectedRevisionId = useWatch({ name: 'hardware_revision_id' });

  return (
    <>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {translate('resources.channel_releases.forms.create.header')}
      </Typography>
      <ReferenceInput reference="hardware" source="hardware_id">
        <AutocompleteInput
          optionText="name"
          label="resources.update_channels.fields.hardware_id"
          defaultValue={record?.hardware_id}
          fullWidth
        />
      </ReferenceInput>
      {selectedHardwareId != null && (
        <ReferenceInput
          reference="hardware_revisions"
          source="hardware_revision_id"
          filter={{ hardware_id: selectedHardwareId }}
        >
          <SelectInput optionText="name" label="resources.update_channels.fields.hardware_revision.name" fullWidth />
        </ReferenceInput>
      )}
      {selectedRevisionId != null && (
        <ReferenceInput
          reference="software_releases"
          source="software_release_id"
          filter={{ hardware_revision_id: selectedRevisionId }}
        >
          <AutocompleteInput optionText="name" fullWidth />
        </ReferenceInput>
      )}
      <ReleaseInputs />
      <TextInput source="update_channel_id" type="hidden" defaultValue={record?.id} sx={{ display: 'none' }} />
    </>
  );
};
